module.exports = __webpack_public_path__ + "media/images/kids11-b3c2e793c38d6330cf7ddeab106761e5.jpg";